import { Component, OnInit, ChangeDetectionStrategy, DestroyRef, inject, input } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ConversationService } from "../../services/conversation.service";
import { filter } from "rxjs";
import { slideFromLeft } from "../../../core-ui/core-ui.animations";
import { ChangeDetectorRef } from "@angular/core";
import {
  ConversationOriginEnum,
  DeviceService,
  IInteraction,
  ToggleConversationPanelAction,
  UserService,
  WindowEventService,
  windowActionType,
} from "../../../core-ui";

@Component({
  selector: "app-conversation-launcher",
  templateUrl: "./conversation-launcher.component.html",
  styleUrls: ["./conversation-launcher.component.scss"],
  animations: [slideFromLeft],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ConversationLauncherComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  private conversation = inject(ConversationService);
  private userService = inject(UserService);
  private windowEventService = inject(WindowEventService);
  private cd = inject(ChangeDetectorRef);

  readonly interaction = input<IInteraction>(undefined);

  isChatOpen = false;
  isLoading = false;
  isStarted = false;
  isCustomer = false;
  ngOnInit(): void {
    this.isCustomer = this.userService.isCustomer;

    if (this.isWidget) {
      this.isStarted = true;
      // listen to widget events that show/hide the widget chat
      this.windowEventService
        .init(this.interaction()?.getParentFrameUrl())
        .pipe(
          filter(
            (action) =>
              action.type === windowActionType.CONVERSATION_PANEL_TOGGLE
          )
        )
        .subscribe((action) => {
          this.isChatOpen = action.payload;
          this.cd.detectChanges();
        });
    } else {
      // we own the widget chat, not the widget
      this.conversation.connected$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
          this.isLoading = true;
          this.cd.detectChanges();
        });
      this.conversation.started$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
          this.isLoading = false;
          this.isStarted = true;
          this.cd.detectChanges();
        });
      this.conversation.ended$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
          this.isStarted = false;
          this.cd.detectChanges();
        });
      this.conversation.conversationPanelToggled$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((open) => {
          this.isChatOpen = open;
          this.cd.detectChanges();
        });
    }
  }

  toggleChat() {
    if (this.isLoading) {
      return;
    }
    if (this.isWidget) {
      this.isChatOpen = !this.isChatOpen;
      this.windowEventService.sendMessage(
        new ToggleConversationPanelAction(this.isChatOpen)
      );
    } else {
      this.conversation.toggleConversationPanel(!this.isChatOpen);
    }
  }

  get isConversationAvailable() {
    return !this.isWidget;
  }

  get isOriginWidget() {
    return this.interaction()?.getOrigin() === ConversationOriginEnum.WIDGET;
  }

  get isWidget() {
    return DeviceService.isIFrame && this.isCustomer && this.isOriginWidget;
  }
}
